// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Link = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Link = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Link = _exports.Link = function Link(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.6064 10.2734C20.4645 8.38023 20.4645 5.31147 18.6064 3.41834C16.8375 1.61616 13.9974 1.51847 12.1127 3.19938L11.9111 3.38128C11.5804 3.67435 11.5474 4.18637 11.835 4.52322C12.1227 4.86008 12.6252 4.89377 12.9559 4.6007L13.1575 4.4188C14.414 3.30044 16.3052 3.36444 17.4855 4.56702C18.7221 5.82686 18.7221 7.87158 17.4855 9.13479L13.7395 12.948C12.5029 14.2078 10.4926 14.2078 9.25608 12.948C8.07572 11.7454 8.01289 9.8186 9.1106 8.53855L9.26599 8.35665C9.55365 8.01979 9.52058 7.51114 9.18995 7.21471C8.85931 6.91827 8.36006 6.95533 8.0691 7.29218L7.9137 7.47409C6.26715 9.39417 6.36303 12.2878 8.13192 14.0899C9.99008 15.9831 13.0021 15.9831 14.8603 14.0899L18.6064 10.2734ZM1.39362 9.5188C-0.46454 11.4119 -0.46454 14.4807 1.39362 16.3705C3.16581 18.176 6.00595 18.2703 7.89056 16.5894L8.09225 16.4075C8.42288 16.1144 8.45594 15.6024 8.16829 15.2656C7.88064 14.9287 7.37808 14.895 7.04745 15.1881L6.84576 15.37C5.58935 16.4884 3.69813 16.4244 2.51777 15.2218C1.2812 13.9619 1.2812 11.9172 2.51777 10.654L6.26384 6.84416C7.50041 5.58432 9.50736 5.58432 10.7472 6.84416C11.9276 8.04674 11.9904 9.97356 10.8927 11.2536L10.7142 11.4591C10.4265 11.796 10.4596 12.3046 10.7902 12.601C11.1208 12.8975 11.6201 12.8604 11.9111 12.5236L12.0896 12.3181C13.7395 10.398 13.6436 7.5044 11.8747 5.69885C10.0165 3.80572 7.00446 3.80572 5.1463 5.69885L1.39362 9.5188Z",
      fill: "currentColor"
    }));
  };
});
